<template>
	<v-card-text v-if="hiddenData">
		<v-toolbar color="blue" class="white--text">
			<v-icon color="white">lock</v-icon>
			<v-toolbar-title>Informacje dodatkowe (ukryte dla oferenta)</v-toolbar-title>
			<v-spacer></v-spacer>
		</v-toolbar>
		<v-btn v-if="editable" class="mt-3 ml-3" color="primary" dark @click="readOnlyMode = !readOnlyMode">
			<v-icon class="ml-1 mr-3">{{ icon }}</v-icon>
			{{ buttonLabel }}
		</v-btn>
		<div class="ma-4">
			<v-layout row>
				<v-flex xs2/>
				<v-flex xs7>
					<v-textarea
						browser-autocomplete="off"
						outline
						label="Informacje dodatkowe"
						for="hidden-profile-data-view-notes"
						id="hidden-profile-data-view-notes"
						aria-label="notes"
						:disabled="readOnlyMode"
						v-model="data.notes"
					></v-textarea>
				</v-flex>
			</v-layout>
		</div>
	</v-card-text>
</template>

<script>
	export default {
		name: "HiddenProfileDataView",

		data () {
			return {
				readOnlyMode: true,

				data: {},
			};
		},

		watch: {
			hiddenData: function () {
				this.data = this.hiddenData;
			},

			readOnlyMode: function (value) {
				this.$emit("edition-status", !value);
			},
		},

		computed: {
			icon () {
				return this.readOnlyMode ? "edit" : "save";
			},

			buttonLabel () {
				return this.readOnlyMode ? "Edytuj" : "Skończ edycję";
			},
		},

		props: {
			hiddenData: Object,
			editable: {
				default: true,
			},
		},
	};
</script>
